import { Modal, VStack, HStack, Button } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface ConfirmModalProps {
  title: string;
  description: string;
  isOpen: boolean;
  isCancelDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal = (p: ConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal className="w-full max-w-[360px]" isOpen={p.isOpen} onClose={p.onCancel}>
      <VStack className="w-full p-[20px] gap-[20px] rounded-[24px] bg-bg-weak/95 backdrop-blur-md shadow-[0_24px_80px_rgba(15,23,42,0.12)]">
        <VStack className="w-full gap-[4px] p-[4px] items-start">
          <span className="text-xl font-semibold text-ct-strong">{p.title}</span>
          <span className="text-sm font-normal text-ct-regular">{p.description}</span>
        </VStack>
        <HStack className="w-full gap-[10px]">
          {!p.isCancelDisabled && (
            <Button className="w-full" onClick={p.onCancel}>{t("common.cancel")}</Button>
          )}
          <Button className="w-full" variant="primary" onClick={p.onConfirm}>{t("common.confirm")}</Button>
        </HStack>
      </VStack>
    </Modal>
  )
}
